/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Filter_RegionInputs */

const en_us2_exercise_filter_region = /** @type {(inputs: Exercise_Filter_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body region`)
};

const pt_br2_exercise_filter_region = /** @type {(inputs: Exercise_Filter_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Região`)
};

const es_419_exercise_filter_region = /** @type {(inputs: Exercise_Filter_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Región`)
};

const pt_pt2_exercise_filter_region = /** @type {(inputs: Exercise_Filter_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Região`)
};

const fr_fr2_exercise_filter_region = /** @type {(inputs: Exercise_Filter_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zone du corps`)
};

const de_de2_exercise_filter_region = /** @type {(inputs: Exercise_Filter_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Körperregion`)
};

const it_it2_exercise_filter_region = /** @type {(inputs: Exercise_Filter_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zona del corpo`)
};

/**
* | output |
* | --- |
* | "Body region" |
*
* @param {Exercise_Filter_RegionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_filter_region = /** @type {((inputs?: Exercise_Filter_RegionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Filter_RegionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_filter_region(inputs)
	if (locale === "es-419") return es_419_exercise_filter_region(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_filter_region(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_filter_region(inputs)
	if (locale === "de-DE") return de_de2_exercise_filter_region(inputs)
	if (locale === "it-IT") return it_it2_exercise_filter_region(inputs)
	return en_us2_exercise_filter_region(inputs)
});
export { exercise_filter_region as "exercise.filter_region" }